import React, { useRef, useState,useEffect } from "react";
import { API_URL,ENDPOINTS } from "../../constants/api";
import { postData } from "../../constants/api";
import Header from "./header";
import MyFooter from "./my footer";
import FeatherIcon from "feather-icons-react";
import "bootstrap/dist/css/bootstrap.min.css";
import { useParams } from "react-router-dom";
import { decodeToken, getToken } from "../../utils/TokenUtils";
const CourseDetail = () => {
    // Create a ref array for multiple videos
  const videoRefs = useRef([]);
  const { courseId } = useParams(); // get courseId from URL
  const [data,setData]=useState([]);
  const token = getToken();
  const std_id = decodeToken(token, "id");

 const handlePlay = (index) => {
    const video = videoRefs.current[index];
    if (video) video.play();
  };
 
   useEffect(() => {
   
     const getCourse = async () => {
      try {
        const url = `${API_URL}/${ENDPOINTS.SYS}/reportCustom/get-course-video-slides`;
        const body = { course_id:courseId,std_id };
        const response = await postData(url, body);
        console.log("response data: ",response);
        setData(response.data);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
      
    };
  
   getCourse();
  }, [courseId]);

  const handleDownload = (url) => {
    const link = document.createElement("a");
    link.href = url;
    link.download = url.split("/").pop();
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <>
      <Header />
     <div className="container-fluid my-5 px-5">
  {/* Department & Title */}
  <h4 className="text-center mb-3 fw-bold text-uppercase text-info">{data[0]?.department}</h4>
  <h3 className="text-center mb-5 fw-bold text-uppercase">{data[0]?.title}</h3>

  {/* Lessons */}
  {data.map((dat, index) => (
    <div key={index} className="mb-5">
      {/* Chapter */}
      <div className="ms-3 mb-3 fw-semibold">{dat.chapter}</div>
      <hr />

      <div
        className="d-flex flex-wrap justify-content-center align-items-start"
        style={{ gap: "5%", rowGap: "2rem" }}
      >
        {/* PPT Section */}
        <div
          className="card shadow-lg border-0 rounded-4"
          style={{ width: "45%", minHeight: "600px" }}
        >
          <div className="card-header bg-primary text-white d-flex align-items-center justify-content-between py-3">
            <div className="fw-semibold">
              <FeatherIcon icon="file-text" className="me-2" />
              Lesson Slides (PPT)
            </div>
          </div>
          <div className="card-body text-center bg-light d-flex flex-column justify-content-between">
            <iframe
              src={`https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(`${API_URL}/${dat.pdf}`)}`}
              width="100%"
              height="500px"
              frameBorder="0"
              title={`PPT Viewer ${index}`}
              className="rounded shadow-sm"
            ></iframe>
            <div className="mt-3 text-center">
              <button
                className="btn btn-primary px-4 py-2 d-flex align-items-center justify-content-center"
                onClick={() => handleDownload(`${API_URL}/${dat.pdf}`)}
              >
                <FeatherIcon icon="download" className="me-2" /> Download PPT
              </button>
            </div>
          </div>
        </div>

        {/* Video Section */}
        <div
          className="card shadow-lg border-0 rounded-4"
          style={{ width: "45%", minHeight: "600px" }}
        >
          <div className="card-header bg-success text-white d-flex align-items-center justify-content-between py-3">
            <div className="fw-semibold">
              <FeatherIcon icon="video" className="me-2" />
              Lesson Video
            </div>
          </div>
          <div className="card-body text-center bg-light d-flex flex-column justify-content-between">
            <video
              ref={(el) => (videoRefs.current[index] = el)}
              width="100%"
              height="500"
              controls
              className="rounded shadow-sm"
            >
              <source src={`${API_URL}/${dat.video}`} type="video/mp4" />
              Your browser does not support HTML video.
            </video>

            <div className="mt-3 d-flex justify-content-center gap-3">
              <button
                className="btn btn-success px-4 py-2 d-flex align-items-center"
                onClick={() => handlePlay(index)}
              >
                <FeatherIcon icon="play" className="me-2" /> Play Now
              </button>
              <button
                className="btn btn-primary px-4 py-2 d-flex align-items-center"
                onClick={() => handleDownload(`${API_URL}/${dat.video}`)}
              >
                <FeatherIcon icon="download" className="me-2" /> Download Video
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  ))}
</div>


 
      <MyFooter />
    </>
  );
};

export default CourseDetail;
